import React from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

export interface ContributionChartProps {
  channels: Array<{ channel: string; contributionPct: number; color: string }>
  currency: string
}

export function ContributionChart({ channels }: ContributionChartProps) {
  const pieData = channels.map(c => ({
    name: c.channel,
    y: c.contributionPct * 100,
    color: c.color,
  }))

  const options: Highcharts.Options = {
    chart: { type: 'pie', height: 280 },
    title: { text: '' },
    tooltip: {
      pointFormat: '<b>{point.percentage:.1f}%</b> of media contribution'
    },
    plotOptions: {
      pie: {
        innerSize: '60%',
        dataLabels: {
          enabled: true,
          format: '{point.name}: {point.percentage:.0f}%',
          style: { fontSize: '11px' }
        },
      }
    },
    series: [{
      name: 'Contribution',
      type: 'pie',
      data: pieData,
    }],
    credits: { enabled: false },
  }

  return (
    <div className="tw-bg-white tw-rounded-lg tw-border tw-border-slate-200 tw-p-6">
      <h3 className="tw-text-lg tw-font-semibold tw-text-slate-900 tw-mb-4">Revenue Contribution by Channel</h3>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  )
}
